import ztComponent from './ztSelect.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
